var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmountsOwedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 348,
    height: 172,
    viewBox: "0 0 348 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 348,
    height: 172,
    rx: 7,
    fill: "#EFEFEF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 135.237,
    height: 84.3077,
    rx: 9.94414,
    transform: "matrix(0.93787 -0.346986 0.333314 0.942816 94 65.9277)",
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 119.517,
    y: 67.481,
    width: 134.874,
    height: 84.5252,
    rx: 9.94414,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 132.883,
    y: 83.6387,
    width: 18.2263,
    height: 18.6453,
    rx: 3.72905,
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 132.883,
    y: 129.636,
    width: 19.4414,
    height: 6.21509,
    rx: 3.10754,
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 162.045,
    y: 129.636,
    width: 19.4414,
    height: 6.21509,
    rx: 3.10754,
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 191.207,
    y: 129.636,
    width: 19.4414,
    height: 6.21509,
    rx: 3.10754,
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 220.369,
    y: 129.636,
    width: 19.4414,
    height: 6.21509,
    rx: 3.10754,
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmountsOwedIcon);
export default __webpack_public_path__ + "static/media/amounts-owed-icon.88d7eb412bbd3e96fa59dbd2ec7071ca.svg";
export { ForwardRef as ReactComponent };